let Footer = () => {
    return <div className="footer">
        <div> &#169;
            <a href='https://github.com/neerajsurjaye' target="_blank" rel="noopener noreferrer">Neeraj Surjaye (2021)</a>
        </div>
    </div>
}

export default Footer;